enum BordereauStateType {
  NOUVEAU = 'Nouveau',
  EN_COURS = 'En cours',
  NUMEROTE = 'Numéroté',
  PES_EN_INSTANCE = 'PES en instance',
  ATTENTE_SIGNATURE = 'Attente signature',
  TRANSMIS_COMPTABLE = 'Transmis au comptable',
  ACQUITTE = 'Acquitté',
  NON_ACQUITTE = 'Non-acquitté',
  REFUSE = 'Refusé',
  EN_ECHEC = 'En échec',
  FLUX_EMIS = 'Flux émis',
  TELETRANSMIS = 'Télétransmis',
  REJETE = 'Rejeté par la comptabilité',
  ARCHIVE = 'Archivé',
  ATTENTE_TRANSMISSION_PARAPHEUR = 'Attente transmission parapheur',
  PREPARE_TDT = 'Préparation TDT',
  INCONNU = 'Inconnu',
  TRAITE_DGFIP = 'Traité par la DGFIP',
}

export default BordereauStateType;
